// extracted by mini-css-extract-plugin
export default {"style":"ConfirmedAppointmentContent_style__0kE+k"};